import * as client_hooks from '../../../src/hooks.client.js';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115')
];

export const server_loads = [];

export const dictionary = {
		"/": [23],
		"/(desktop-app)/activity-logs": [24,[2]],
		"/(desktop-app)/analysis": [25,[2,3]],
		"/(desktop-app)/analysis/session": [26,[2,3]],
		"/(desktop-app)/analysis/star": [27,[2,3]],
		"/(desktop-app)/analysis/subject": [28,[2,3]],
		"/(desktop-app)/analysis/term": [29,[2,3]],
		"/(desktop-app)/broadsheet": [30,[2]],
		"/(desktop-app)/classrooms": [31,[2,4]],
		"/(desktop-app)/classrooms/[id]": [32,[2,4]],
		"/(desktop-app)/credits": [33,[2]],
		"/(desktop-app)/dashboard": [34,[2]],
		"/(desktop-app)/e-learning": [35,[2,5]],
		"/(desktop-app)/e-learning/[id]": [36,[2,5]],
		"/(desktop-app)/finance/all-history": [37,[2,6]],
		"/(desktop-app)/finance/all-history/[id]": [38,[2,6]],
		"/(desktop-app)/finance/dashboard": [39,[2]],
		"/(desktop-app)/finance/fee-schedule-requests": [44,[2]],
		"/(desktop-app)/finance/fee-schedule": [40,[2,7]],
		"/(desktop-app)/finance/fee-schedule/classroom": [41,[2,7]],
		"/(desktop-app)/finance/fee-schedule/classroom/[id]": [42,[2,7]],
		"/(desktop-app)/finance/fee-schedule/classroom/[id]/student/[sid]": [43,[2,7]],
		"/(desktop-app)/finance/fee-settlements": [45,[2]],
		"/(desktop-app)/finance/income": [46,[2]],
		"/(desktop-app)/finance/outstanding": [47,[2,9]],
		"/(desktop-app)/finance/outstanding/[id]": [48,[2,9]],
		"/(desktop-app)/finance/refunds": [49,[2]],
		"/(desktop-app)/finance/split-fees": [50,[2]],
		"/(desktop-app)/finance/split-fees/list": [51,[2]],
		"/(desktop-app)/finance/student-fees-details": [53,[2]],
		"/(desktop-app)/finance/student-fees": [52,[2]],
		"/(desktop-app)/finance/students-accounts": [54,[2]],
		"/(desktop-app)/finance/transaction-history": [55,[2,10]],
		"/(desktop-app)/finance/transaction-history/[id]": [56,[2,10]],
		"/(desktop-app)/login": [57,[2]],
		"/(mobile-app)/mobile": [103,[21,22]],
		"/(mobile-app)/mobile/finance": [104,[21,22]],
		"/(mobile-app)/mobile/finance/dashboard": [105,[21,22]],
		"/(mobile-app)/mobile/finance/income": [106,[21,22]],
		"/(mobile-app)/mobile/finance/student-accounts": [107,[21,22]],
		"/(mobile-app)/mobile/finance/student-accounts/create/[id]": [108,[21,22]],
		"/(mobile-app)/mobile/finance/student-fees": [109,[21,22]],
		"/(mobile-app)/mobile/report-comments": [110,[21,22]],
		"/(mobile-app)/mobile/scoresheet": [111,[21,22]],
		"/(mobile-app)/mobile/students": [112,[21,22]],
		"/(mobile-app)/mobile/students/add": [113,[21,22]],
		"/(mobile-app)/mobile/students/edit/[id]": [114,[21,22]],
		"/(mobile-app)/mobile/subject-comments": [115,[21,22]],
		"/(desktop-app)/non-academics": [58,[2,11]],
		"/(desktop-app)/non-academics/attendance": [59,[2,11]],
		"/(desktop-app)/non-academics/observation": [60,[2,11]],
		"/(desktop-app)/non-academics/psychomotor": [61,[2,11]],
		"/(desktop-app)/non-academics/spiritual-development": [62,[2,11]],
		"/(desktop-app)/parents": [63,[2,12]],
		"/(desktop-app)/parents/split-fees": [64,[2,12]],
		"/(desktop-app)/parents/students": [65,[2,12,13]],
		"/(desktop-app)/parents/students/[id]": [66,[2,12,13]],
		"/(desktop-app)/report-comments": [67,[2]],
		"/(desktop-app)/reports/promotion-repeated-list": [68,[2]],
		"/(desktop-app)/reports/verification": [69,[2]],
		"/(desktop-app)/scoresheet": [70,[2,14]],
		"/(desktop-app)/scoresheet/[id]": [71,[2,14]],
		"/(desktop-app)/settings": [72,[2,15]],
		"/(desktop-app)/settings/ca-scheme": [74,[2,15]],
		"/(desktop-app)/settings/grading-scheme": [75,[2,15]],
		"/(desktop-app)/settings/logo": [76,[2,15]],
		"/(desktop-app)/settings/non-academics": [77,[2,15]],
		"/(desktop-app)/settings/publish-result": [78,[2,15]],
		"/(desktop-app)/settings/remove-leaked-data": [79,[2,15]],
		"/(desktop-app)/settings/report-promotion": [80,[2,15]],
		"/(desktop-app)/settings/signature": [81,[2,15]],
		"/(desktop-app)/settings/term": [82,[2,15]],
		"/(desktop-app)/settings/[id]": [73,[2,15]],
		"/(desktop-app)/staff": [83,[2,16]],
		"/(desktop-app)/staff/add": [85,[2,16]],
		"/(desktop-app)/staff/recruitment": [86,[2,16]],
		"/(desktop-app)/staff/[id]": [84,[2,16]],
		"/(desktop-app)/students": [87,[2,17]],
		"/(desktop-app)/students/add": [89,[2,17]],
		"/(desktop-app)/students/import": [90,[2,17]],
		"/(desktop-app)/students/move": [91,[2,17]],
		"/(desktop-app)/students/[id]": [88,[2,17]],
		"/(desktop-app)/subject-comments": [92,[2]],
		"/(desktop-app)/subjects": [93,[2,18]],
		"/(desktop-app)/subjects/add": [95,[2,18]],
		"/(desktop-app)/subjects/[id]": [94,[2,18]],
		"/(desktop-app)/teachers": [96,[2,19]],
		"/(desktop-app)/teachers/add": [98,[2,19]],
		"/(desktop-app)/teachers/[id]": [97,[2,19]],
		"/(desktop-app)/users": [99,[2,20]],
		"/(desktop-app)/users/add": [101,[2,20]],
		"/(desktop-app)/users/[slug]": [100,[2,20]],
		"/(desktop-app)/visualize-report": [102,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';